import { NotificationsState, ToastNotification } from './types';
import { PayloadAction } from '@reduxjs/toolkit';

export const reducers = {
  setNotification(
    state: NotificationsState,
    action: PayloadAction<ToastNotification>,
  ) {
    state.notifications.push(action.payload);
    state.isVisible = true;
  },
  dismissNotification(
    state: NotificationsState,
    action: PayloadAction<string>,
  ) {
    const notificationIndex = state.notifications.findIndex(
      notification => notification.timeoutId === action.payload,
    );
    state.notifications.splice(notificationIndex, 1);
    if (state.notifications.length === 0) {
      state.isVisible = false;
    }
  },
};
